import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { FirebaseLoginService } from '../_services/firebase-login.service';
import { LoginService } from '../_services/login.service';

@Injectable()
export class UserAuthGuard implements CanActivate {

  constructor(private _login: LoginService, private _router: Router, private _firebaseLoginService: FirebaseLoginService) {}

  canActivate(): boolean {
    const logged = this._login.isLogged();
    const loggedFire = this._firebaseLoginService.isLoggedInFire();

    if (logged || loggedFire) { // logged
      return true;
    }

    this._router.navigate(['/login']);
    return false;
  }
}
